import USDA from '../images/emblems/usda.png';

export const Usda = () => <div>

    <div>
        <img src={USDA} alt="USDAオーガニック認証" />
    </div>
    <span>この商品はUSDAオーガニック認証を取得しています</span>
    <h3>USDAオーガニック認証<br />（有機農産物認証）</h3>

    USDAオーガニック認証とは
    USDA（United States Department of Agriculture）
    はアメリカ合衆国農務省が運営する米国の有機（オーガニック）認証制度です。合成農薬・化学肥料・遺伝子組換え（GMO）などを使用せず生産された製品に与えられる、世界的に高い信頼性を持つ認証です。

    <ul>
        <li>合成農薬</li>
        <li>化学肥料</li>
        <li>遺伝子組換え原料（GMO）</li>
        <li>合成化学物質</li>
        <li>人工香料</li>
        <li>合成保存料</li>
        <li>放射線照射処理</li>
        <li>汚泥肥料</li>
    </ul>

    一切使用していない100%天然オーガニックになります。

</div>;
